export default __webpack_public_path__ + "static/media/README.4a57f201.md";